import ProdCards from './components/common/ProdCards';
import useFetch from '@/api/useFetch';

const Index = (props) => {
  const { response } = useFetch('getGames');

  return (
    <div className="mod" style={{marginTop: 50, minHeight: '72vh'}}>
      <ProdCards list={response || []} />
    </div>
  )
}

export default Index
